module.exports = __webpack_public_path__ + "img/3.ee4b3d5b.jpg";